<template>
  <div class="body-property-section">
    <n-card size="small" embedded>
      <n-space vertical size="small">
        <div class="row">
          <n-text depth="3">Type</n-text>
          <n-text strong>Solid Body</n-text>
        </div>
        <div class="row">
          <n-text depth="3">Created by</n-text>
          <n-text>{{ createdBy }}</n-text>
        </div>
      </n-space>
    </n-card>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { NCard, NSpace, NText } from 'naive-ui';
import type { PropertyManagerContext } from '@/core';

interface Props {
  context: PropertyManagerContext;
}

const props = defineProps<Props>();

const createdBy = computed(() => {
  const metadata = props.context.selectedObject?.metadata as Record<string, unknown> | undefined;
  const created = metadata?.createdByFeatureId;
  return typeof created === 'string' && created.length > 0 ? created : '-';
});
</script>

<style scoped>
.row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}
</style>

